<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <trial-modal :visible="trialVisible" :diagnose="trialDiagnose" @close="closeTrialModal" />
    <brand-notice v-if="$route.path === '/index'" />
  </div>
</template>

<script>
import store from "@/store";
import router from '@/router';
import trialModal from '@/page/index/components/trial-modal';
import brandNotice from 'basecommon/components/brand-notice.js';
import Vue from 'vue'
  export default {
    name: 'App',
    components: { trialModal, brandNotice },
    data() {
      return { trialVisible: false, trialDiagnose: false };
    },

    mounted () {
        this.$root.$on('diagnose', this.openTrialModal);
        // 检查登录状态
        this.getLoginStats();
    },

    beforeDestroy() {
      this.$root.$off('diagnose', this.openTrialModal);
    },

    watch: {
      //监听路由变化
      "$route": {
        handler() {
          if (this.$route) {
            this.getLoginStats()
          }
          return
        },
        immediate: true
      }
    },

    methods: {
      openTrialModal() {
        this.trialDiagnose = true;
        this.trialVisible = true;
      },
      closeTrialModal() {
        this.trialVisible = false;
        this.trialDiagnose = false;
      },
      //检查登录状态
      getLoginStats() {
        //手机跳出
        // if(this.$isFe) return;
        //首页和登录等路由 不需要验证登录
        let routeArr = [ '/', '/index', '/indexFe', '/strongMath', '/downApp', '/schoolIndex', '/loginCode', '/loginPassword', '/refundProtocol', '/teachersTeam',   "/about",
        "/contact",
        "/schoolDetail"]
        if(routeArr.includes(this.$router.currentRoute.path)) return;
         const studentCode = store.state.user.Code;
        if (!studentCode) {
        // Vue.prototype.$toast.center("未登录，请先登录");
        localStorage.removeItem("user");
        router.replace({
          path: "/loginCode",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      }
      },

    },

  }
</script>



// WEBPACK FOOTER //
// src/App.vue